import { exhaustMap } from 'rxjs';
import { inject } from '@angular/core';
import { CrewDashboardState } from '@navstation-portal/reporting/data-model/crew-dashboard';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature, type } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { CrewDashboardService } from '../crew-dashboard-service/crew-dashboard.service';
import { crewDashboardEvents } from './crew-dashboard-events';

export function withCrewDashboardEffects() {
  return signalStoreFeature(
    type<{ state: CrewDashboardState }>(),
    withEventHandlers(() => {
      const events = inject(Events);
      const service = inject(CrewDashboardService);

      return {
        fetchDashboardData$: events.on(crewDashboardEvents.fetchDashboardData).pipe(
          exhaustMap(({ payload: selectedVesselId }) => {
            const vesselId = selectedVesselId;

            if (!vesselId) {
              console.error('No default vessel ID found for the user. Crew dashboard data cannot be loaded.');
              return [];
            }

            return service.getDashboardData(vesselId).pipe(
              mapResponse({
                next: (payload) => {
                  return crewDashboardEvents.fetchDashboardDataSuccess(payload);
                },
                error: (err: Error) => {
                  console.error('getDashboardData error:', err);
                  return crewDashboardEvents.fetchDashboardDataFailed(err);
                },
              })
            );
          })
        ),
      };
    })
  );
}
